import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import allReducers from './globalState';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './pages/QuoteStep/styles.css';
import './pages/styles.css';
import './pages/QuoteStep/newStyle.css'

const store = configureStore({ reducer: allReducers });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HashRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </HashRouter>
  // </React.StrictMode>
);
